/* eslint-disable camelcase */
import { dateTimeService } from '@mdc/services';

const getHumanizedDate = (date, lang) => dateTimeService.getDateHourString(date, lang);
const getMergedString = (accessor, mergeAccessors) => {
    return Object.entries(mergeAccessors).map(([key]) => {
        const value = mergeAccessors[key]?.value || '';
        if (mergeAccessors[key].symbol === '&nbsp') {
            if (mergeAccessors[key].key === 'geoLocation') {
                return mergeAccessors[key]?.value?.country && mergeAccessors[key]?.value?.city ? <div className='d-flex flex-row align-items-top pt-2'>
                    <i className='icon icon-location'/>
                    <p className='mb-0'>{`${mergeAccessors[key].value?.country} - ${mergeAccessors[key].value?.city}`}</p>
                </div> : '';
            }
            return <p>{value}</p>;
        } else if (mergeAccessors[key].symbol === ':') {
            // Port should be added next to the accessor
            return accessor + '' + mergeAccessors[key].symbol + '' + value;
        }

        if (value) {
            return ' ' + mergeAccessors[key].symbol + ' ' + value;
        }

        return '';
    });
};

export default (t, lang) => {
    return {
        tcp: [
            {
                Header: t('Time (GMT + 7)'),
                accessor: 'timestamp',
                parser: (data) => getHumanizedDate(data, lang)
            },
            {
                Header: t('From'),
                accessor: 'src_host',
                mergeAccessors: [
                    {
                        key: 'src_port',
                        symbol: ':'
                    }
                ],
                mergeAccessorParser: (accessor, mergeAccessors) => getMergedString(accessor, mergeAccessors)
            },
            {
                Header: t('To'),
                accessor: 'dst_host',
                mergeAccessors: [
                    {
                        key: 'dst_port',
                        symbol: ':',
                    },
                    {
                        key: 'query',
                        symbol: '-'
                    },
                    {
                        key: 'geoLocation',
                        symbol: '&nbsp'
                    }
                ],
                mergeAccessorParser: (accessor, mergeAccessors) => getMergedString(accessor, mergeAccessors)
            },
        ],
        udp: [
            {
                Header: t('Time (GMT + 7)'),
                accessor: 'timestamp',
                parser: (data) => getHumanizedDate(data, lang)
            },
            {
                Header: t('From'),
                accessor: 'src_host',
                mergeAccessors: [
                    {
                        key: 'src_port',
                        symbol: ':'
                    }
                ],
                mergeAccessorParser: (accessor, mergeAccessors) => getMergedString(accessor, mergeAccessors)
            },
            {
                Header: t('To'),
                accessor: 'dst_host',
                mergeAccessors: [
                    {
                        key: 'dst_port',
                        symbol: ':',
                    },
                    {
                        key: 'query',
                        symbol: '-'
                    },
                    {
                        key: 'geoLocation',
                        symbol: '&nbsp'
                    }
                ],
                mergeAccessorParser: (accessor, mergeAccessors) => getMergedString(accessor, mergeAccessors)
            },
        ],
        http: [
            {
                Header: t('Time (GMT + 7)'),
                accessor: 'timestamp',
                parser: (data) => getHumanizedDate(data, lang)
            },
            {
                Header: t('From'),
                accessor: 'src_host',
                mergeAccessors: [
                    {
                        key: 'src_port',
                        symbol: ':'
                    }
                ],
                mergeAccessorParser: (accessor, mergeAccessors) => getMergedString(accessor, mergeAccessors)
            },
            {
                Header: t('To'),
                accessor: 'dst_host',
                mergeAccessors: [
                    {
                        key: 'dst_port',
                        symbol: ':',
                    },
                    {
                        key: 'query',
                        symbol: '-'
                    },
                    {
                        key: 'geoLocation',
                        symbol: '&nbsp'
                    }
                ],
                mergeAccessorParser: (accessor, mergeAccessors) => getMergedString(accessor, mergeAccessors)
            },
        ],
    };
};
